module.exports = __webpack_public_path__ + "images/about@2x.png?e71ee693";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about@2x.png
// module id = 592
// module chunks = 7